import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Input,
  Row,
  Col,
  Select,
  Space,
  Tabs,
  Card,
  message,
  Checkbox
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  KeyOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  create_permission,
  create_users,
  delete_users,
  get_all_permissions,
  get_all_users,
  update_users,
  get_user_permissions,
  update_user_permissions
} from "../../api/users";
import {
  createRegion,
  deleteRegion,
  get_ListeRegion,
  updateRegion,
} from "../../api/region";
import {
  createSite,
  deleteSite,
  get_ListeSite,
  updateSite,
} from "../../api/site";
import {
  get_ListeType,
  updateType,
  deleteType,
  createType,
} from "../../api/type";
import { getPermissionsFromToken, hasPermission } from "../../utils/utils";

const { Option } = Select;
const { TabPane } = Tabs;



const Utility = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalDisableUser, setisModalDisableUser] = useState(false);

  const [listeUsers, setlisteUsers] = useState([]);
  const [currentUser, setcurrentUser] = useState({
    id: 0,
    email: null,
    password: null,
    nom: null,
    prenom: null,
    fonction_id: null,
    password_confirm: null,
    mobile: "",
    agence_id: 1
  });
  const [isUpdate, setisUpdate] = useState(false);
  const [isUpdateRegion, setisUpdateRegion] = useState(false);
  const [isUpdateSite, setisUpdateSite] = useState(false);
  const [isUpdateType, setisUpdateType] = useState(false);
  const [isModalOpenRegion, setisModalOpenRegion] = useState(false);
  const [isModalOpenSite, setisModalOpenSite] = useState(false);
  const [isModalOpenType, setisModalOpenType] = useState(false);
  const [isModalDeleteRegion, setisModalDeleteRegion] = useState(false);
  const [isModalDeleteSite, setisModalDeleteSite] = useState(false);
  const [isModalDeleteType, setisModalDeleteType] = useState(false);
  const [ListeRegion, setListeRegion] = useState([]);
  const [selectedRegion, setselectedRegion] = useState({
    id: 0,
    nom: "",
  });
  const [listeType, setlisteType] = useState([]);
  const [selectedType, setselectedType] = useState({
    id: 0,
    nom: null,
  });
  const [listeSite, setlisteSite] = useState([]);
  const [selectedSite, setselectedSite] = useState({
    id: 0,
    nom: "",
  });

  // const [isPermissionModalOpen, setIsPermissionModalOpen] = useState(false);
  const [isCreatePermissionModalOpen, setIsCreatePermissionModalOpen] = useState(false);
  const [isAssignPermissionModalOpen, setIsAssignPermissionModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [listePermission, setlistePermission] = useState([]);
  const [permissionData, setPermissionData] = useState({
    nom: "",
    description: "",
  });
  const [permissions, setPermissions] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);
  const [searchPermission, setSearchPermission] = useState("");

  const filteredPermissions = listePermission.filter(
    (p) =>
      p.nom.toLowerCase().includes(searchPermission.toLowerCase()) ||
      (p.description || "")
        .toLowerCase()
        .includes(searchPermission.toLowerCase())
  );
  const [isloading, setisloading] = useState(false)

  useEffect(() => {
    fetchUsers();
    fetchRegion();
    fetchSite();
    fetchType();
    fetchPermissions()
  }, []);

  const fetchUsers = async () => {
    const res = await get_all_users();
    console.log(res.data);
    setlisteUsers(res.data);
  };

  const fetchPermissions = async () => {
    const res = await get_all_permissions();
    setlistePermission(res.data);
  };

  const fetchRegion = async () => {
    const res = await get_ListeRegion();
    setListeRegion(res.data);
  };

  const fetchSite = async () => {
    const res = await get_ListeSite();
    setlisteSite(res.data);
  };

  const fetchType = async () => {
    const res = await get_ListeType(selectedType);
    setlisteType(res.data);
  };

  const openModal = (item = null) => {
    setcurrentUser(item);
    setIsModalOpen(true);
  };

  const openModalDisableUser = (item = null) => {
    setcurrentUser(item);
    setisModalDisableUser(true);
  };

  const handleOkDisableUser = async () => {
    setisloading(true)
    const res = await delete_users(currentUser);
    if (res["status"] === "success") {
      alert("Utilisateur supprimé avec succes !!!");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      alert("Erreur suppression de l'utilisateur !!!");
      setisloading(false)
    }
  };


  const columns_table_region = [
    {
      title: "ID",
      dataIndex: "id",
      key: "ID",
      align: "center",
    },
    {
      title: "Nom",
      dataIndex: "nom",
      key: "nom",
      align: "center",
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <div style={{ textAlign: "center" }}>
          <Space>
            {
              hasPermission(getPermissionsFromToken(), "UPDATE_SETTINGS_REGION") && <Button
                className="btn btn-warning"
                onClick={() => {
                  openModalRegion(record);
                  setisUpdateRegion(true);
                }}
                icon={<EditOutlined />}
              />
            }

            {
              hasPermission(getPermissionsFromToken(), "DELETE_SETTINGS_REGION") && <Button
                className="btn btn-danger"
                onClick={() => openModalDeleteRegion(record)}
                icon={<DeleteOutlined />}
              />
            }

          </Space>
        </div>
      ),
    },
  ];

  const columns_table_site = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      align: "center",
    },
    {
      title: "Nom",
      dataIndex: "nom",
      key: "nom",
      align: "center",
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <div style={{ textAlign: "center" }}>
          <Space>
            {
              hasPermission(getPermissionsFromToken(), "UPDATE_SETTINGS_SITE") && <Button
                className="btn btn-warning"
                icon={<EditOutlined />}
                onClick={() => {
                  openModalSite(record);
                  setisUpdateSite(true);
                }}
              />
            }

            {
              hasPermission(getPermissionsFromToken(), "DELETE_SETTINGS_SITE") && <Button
                className="btn btn-danger"
                icon={<DeleteOutlined />}
                onClick={() => openModalDeleteSite(record)}
              />
            }

          </Space>
        </div>
      ),
    },
  ];

  const columns_table_type = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      align: "center",
    },
    {
      title: "Nom",
      dataIndex: "nom",
      key: "nom",
      align: "center",
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (i, record) => (
        <div style={{ textAlign: "center" }}>
          <Space>
            {
              hasPermission(getPermissionsFromToken(), "UPDATE_SETTINGS_TYPE") && <Button
                className="btn btn-warning"
                icon={<EditOutlined />}
                onClick={() => {
                  openModalType(record);
                  setisUpdateType(true);
                }}
              />
            }

            {
              hasPermission(getPermissionsFromToken(), "DELETE_SETTINGS_TYPE") && <Button
                className="btn btn-danger"
                icon={<DeleteOutlined />}
                onClick={() => OpenModalDeleteType(record)}
              />
            }

          </Space>
        </div>
      ),
    },
  ];

  const columns_table_user = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      align: "center",
    },
    {
      title: "Nom",
      dataIndex: "nom",
      key: "nom",
      align: "center",
    },
    {
      title: "Prenom",
      dataIndex: "prenom",
      key: "prenom",
      align: "center",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      align: "center",
    },
    {
      title: "Actions",
      key: "actions",
      render: (i, record) => (
        <Space>
          {
            hasPermission(getPermissionsFromToken(), "UPDATE_SETTINGS_USER") && <Button
              className="btn btn-warning"
              onClick={() => {
                openModal(record);
                setisUpdate(true);
              }}
              icon={<EditOutlined />}
            />
          }

          {
            hasPermission(getPermissionsFromToken(), "DELETE_SETTINGS_USER") && <Button
              className="btn btn-danger"
              onClick={() => openModalDisableUser(record)}
              icon={<DeleteOutlined />}
            />
          }

          {
            hasPermission(getPermissionsFromToken(), "MANAGE_SETTINGS_USER_PERMISSION") && <Button
              type="primary"
              size="small"
              onClick={() => openPermissionModal(record)}
              icon={<KeyOutlined />}
            />
          }

        </Space>
      ),
    },
  ];

  // --- Handlers région / site / type / user (inchangés) ---
  const handleEditUser = async () => {
    if (isUpdate) {
      if (
        currentUser.id === null ||
        currentUser.email === null ||
        currentUser.fonction_id === null
      ) {
        alert("Champs obligatoires non renseignés");
      } else {
        setisloading(true)
        if (currentUser.password === currentUser.password_confirm) {
          const res = await update_users(currentUser);
          if (res["status"] === "success") {
            alert("User modifié avec succés");
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          } else {
            alert("Erreur modification user");
          }
        } else {
          alert("Mot de passe non valide !!!");
        }
      }
    } else {
      if (
        currentUser.password === null ||
        currentUser.email === null ||
        currentUser.fonction_id === null
      ) {
        alert("Champs obligatoires non renseignés");
      } else {
        setisloading(true)
        const res = await create_users(currentUser);
        if (res["status"] === "success") {
          alert("User crée avec succés");
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          alert("Erreur creation user");
        }
      }
    }
  };

  const handleEditRegion = async () => {
    if (!selectedRegion.nom) {
      alert("Champ obligatoire non renseigné !");
    } else {
      setisloading(true)
      let res;
      if (isUpdateRegion) {
        res = await updateRegion(selectedRegion);
      } else {
        res = await createRegion(selectedRegion);
      }
      if (res.status === "success") {
        alert(
          isUpdateRegion ? "Région modifié avec succès!" : "Région crée avec succès!"
        );
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        alert("Erreur lors de la sauvegarde !");
        setisloading(false)
      }
    }
  };

  const handleEditSite = async () => {
    if (!selectedSite.nom) {
      alert("Champ obligatoire non renseigné !");
    } else {
      let res;
      if (isUpdateSite) {
        res = await updateSite(selectedSite);
      } else {
        res = await createSite(selectedSite);
      }
      if (res.status === "success") {
        alert(isUpdateSite ? "Site modifié avec succès!" : "Site crée avec succès!");
        window.location.reload();
      } else {
        alert("Erreur lors de la sauvegarde! ");
      }
    }
  };

  const handleEditType = async () => {
    if (!selectedType.nom) {
      alert("Champ obligatoire non renseigné!");
    } else {
      let res;
      if (isUpdateType) {
        res = await updateType(selectedType);
      } else {
        res = await createType(selectedType);
      }
      if (res.status === "success") {
        alert(
          isUpdateType
            ? "Type de camion modifié avec succès!"
            : "Type de camion crée avec succès! "
        );
        window.location.reload();
      } else {
        alert("Erreur lors de la sauvegarde !");
      }
    }
  };

  const handleDeleteRegion = async () => {
    setisloading(true)
    const res = await deleteRegion(selectedRegion);
    if (res["status"] === "success") {
      alert("Région supprimé avec succès!");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      alert("Erreur lors de la suppression du région!");
      setisloading(false)
    }
  };

  const handleDeleteSite = async () => {
    setisloading(true)
    const res = await deleteSite(selectedSite);
    if (res["status"] === "success") {
      alert("Site supprimé avec succès");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      alert("Erreur lors de la suppression du site");
      setisloading(false)
    }
  };

  const handleDeleteType = async () => {
    setisloading(true)
    const res = await deleteType(selectedType);
    if (res["status"] === "success") {
      alert("Type de camion supprimé avec succès!");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      alert("Erreur lors de la suppression du type");
      setisloading(false)
    }
  };

  const openModalDeleteRegion = (item = null) => {
    setselectedRegion(item);
    setisModalDeleteRegion(true);
  };

  const openModalDeleteSite = (item = null) => {
    setselectedSite(item);
    setisModalDeleteSite(true);
  };

  const OpenModalDeleteType = (item = null) => {
    setselectedType(item);
    setisModalDeleteType(true);
  };

  const openModalRegion = (item = null) => {
    setselectedRegion(item);
    setisModalOpenRegion(true);
  };

  const openModalSite = (item = null) => {
    setselectedSite(item);
    setisModalOpenSite(true);
  };

  const openModalType = (item = null) => {
    setselectedType(item);
    setisModalOpenType(true);
  };


  const handleCreatePermission = async () => {
    if (!permissionData.nom) {
      message.warning("Nom obligatoire");
      return;
    }

    try {
      await create_permission(permissionData);

      message.success("Permission créée");

      // 🔥 fermer LE BON modal
      setIsCreatePermissionModalOpen(false);

      // reset form
      setPermissionData({ nom: "", description: "" });

      // refresh la liste
      fetchPermissions();
    } catch (err) {
      message.error("Erreur lors de la création");
    }
  };

  const openPermissionModal = async (user) => {
    setSelectedUser(user);
    setUserPermissions([]);

    try {
      const userPermsRes = await get_user_permissions(user.id);
      setUserPermissions(userPermsRes.data.map((p) => p.id));
    } catch (e) {
      message.error("Erreur chargement permissions");
    }

    setIsAssignPermissionModalOpen(true);
  };


  // const handleSavePermissions = async () => {
  //   try {
  //     await update_user_permissions({
  //       user_id: selectedUser.id,
  //       permissions: userPermissions,
  //     });

  //     message.success("Permissions mises à jour");
  //     setIsPermissionModalOpen(false);
  //   } catch (e) {
  //     message.error("Erreur mise à jour permissions");
  //   }
  // };

  const handleSavePermissions = async () => {
    try {
      await update_user_permissions({
        user_id: selectedUser.id,
        permissions: userPermissions,
      });

      message.success("Permissions mises à jour");

      // 🔥 fermer le modal d’attribution
      setIsAssignPermissionModalOpen(false);

      // optionnel : clean state
      setSelectedUser(null);
      setUserPermissions([]);
    } catch (e) {
      message.error("Erreur mise à jour permissions");
    }
  };

  const togglePermission = (permissionId, checked) => {
    setUserPermissions((prev) =>
      checked
        ? [...prev, permissionId]
        : prev.filter((id) => id !== permissionId)
    );
  };

  return (
    <div style={{}}>
      <Card bordered={false}>
        <Tabs defaultActiveKey="1" type="card" style={{ height: '70vh'}}>
          {/* Onglet 1 : Utilisateurs */}
          <TabPane tab="Utilisateurs" key="1">
            <Row>
              {
                hasPermission(getPermissionsFromToken(), "CREATE_SETTINGS_USER") && <Col span={2}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => openModal("type")}
                    style={{ marginBottom: 10 }}
                  >
                    Ajouter
                  </Button>
                </Col>
              }

              {
                hasPermission(getPermissionsFromToken(), "CREATE_SETTINGS_PERMISSION") && <Col span={2}>
                  <Button
                    type="info"
                    icon={<PlusOutlined />}
                    // onClick={() => setIsPermissionModalOpen(true)}
                    onClick={() => setIsCreatePermissionModalOpen(true)}
                    style={{ marginBottom: 10 }}
                  >
                    CREER PERMISSION
                  </Button>
                </Col>
              }

            </Row>
            <div style={{ width: "100%", height: '100%' }}>
              <Table
                pagination={{
                  pageSize: 10,
                  position: ["bottomCenter"],
                  className: "custom-pagination",
                  style: {
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 12,
                  },
                  itemRender: (page, type, originalElement) => {
                    if (type === "page") {
                      return (
                        <div
                          style={{
                            borderRadius: "50%",
                            minWidth: 32,
                            height: 32,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #d9d9d9",
                          }}
                        >
                          {page}
                        </div>
                      );
                    }
                    return originalElement;
                  },
                }}
                columns={columns_table_user}
                dataSource={listeUsers}
                rowKey="id"
                style={{ width: "100%", height: 600, overflowY: "auto", overflowX: "hidden" }}
              />
            </div>
          </TabPane>

          {/* Onglet 2 : Régions */}
          <TabPane tab="Régions" key="2">
            {
              hasPermission(getPermissionsFromToken(), "CREATE_SETTINGS_REGION") && <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => openModalRegion("type")}
                style={{ marginBottom: 10 }}
              >
                Ajouter
              </Button>
            }

            <div style={{ width: "100%" }}>
              <Table
                pagination={{
                  pageSize: 10,
                  position: ["bottomCenter"],
                  className: "custom-pagination",
                  style: {
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 5,
                  },
                  itemRender: (page, type, originalElement) => {
                    if (type === "page") {
                      return (
                        <div
                          style={{
                            borderRadius: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #d9d9d9",
                          }}
                        >
                          {page}
                        </div>
                      );
                    }
                    return originalElement;
                  },
                }}
                columns={columns_table_region}
                dataSource={ListeRegion}
                rowKey="id"
                style={{ width: "100%", height: 600, overflowY: "auto", overflowX: "hidden" }}
              />
            </div>
          </TabPane>

          {/* Onglet 3 : Sites */}
          <TabPane tab="Sites" key="3">
            {
              hasPermission(getPermissionsFromToken(), "CREATE_SETTINGS_SITE") &&  <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => openModalSite("type")}
              style={{ marginBottom: 10 }}
            >
              Ajouter
            </Button>
            }
           
            <div style={{ width: "100%" }}>
              <Table
                pagination={{
                  pageSize: 10,
                  position: ["bottomCenter"],
                  className: "custom-pagination",
                  style: {
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 5,
                    right: 0,
                  },
                  itemRender: (page, type, originalElement) => {
                    if (type === "page") {
                      return (
                        <div
                          style={{
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #d9d9d9",
                          }}
                        >
                          {page}
                        </div>
                      );
                    }
                    return originalElement;
                  },
                }}
                columns={columns_table_site}
                dataSource={listeSite}
                rowKey="id"
                style={{ width: "100%", height: 600, overflowY: "auto", overflowX: "hidden" }}
              />
            </div>
          </TabPane>

          {/* Onglet 4 : Types de Camion */}
          <TabPane tab="Types de Camion" key="4">
            {
              hasPermission(getPermissionsFromToken(), "CREATE_SETTINGS_TYPE") &&  <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => openModalType("type")}
              style={{ marginBottom: 10 }}
            >
              Ajouter
            </Button>
            }
           
            <div style={{ width: "100%" }}>
              <Table
                pagination={{
                  pageSize: 10,
                  position: ["bottomCenter"],
                  className: "customPagination",
                  style: {
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 5,
                  },
                  itemRender: (page, type, originalElement) => {
                    if (type === "page") {
                      return (
                        <div
                          style={{
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #d9d9d9",
                          }}
                        >
                          {page}
                        </div>
                      );
                    } else {
                      return originalElement;
                    }
                  },
                }}
                columns={columns_table_type}
                dataSource={listeType}
                rowKey="id"
                style={{ width: "100%", height: 600, overflowY: "auto", overflowX: "hidden" }}
              />
            </div>
          </TabPane>
        </Tabs>
      </Card>

      {/* ====== Modals ====== */}
      <Modal
        open={isModalOpen}
        title={isUpdate ? "Modifier User" : "Ajouter utilisateur"}
        onCancel={() => {
          setIsModalOpen(false);
          setcurrentUser({});
          setisUpdate(false);
        }}
        onOk={handleEditUser}
        okText={isUpdate ? "Mettre à jour" : "Ajouter"}
        cancelText="Annuler"
        width={800}
        style={{ top: 10 }}
        confirmLoading={isloading}
      >
        <Row>
          <Col span={12}>
            <Row>
              <Col span={8} style={{ textAlign: "center", padding: 5 }}>
                <span>Email</span>
              </Col>
              <Col span={16}>
                <Input
                  size="medium"
                  value={currentUser?.email}
                  onChange={(e) => {
                    setcurrentUser({
                      ...currentUser,
                      email: e.target.value,
                    });
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={8} style={{ textAlign: "center", padding: 5 }}>
                <span>Nom</span>
              </Col>
              <Col span={16}>
                <Input
                  size="medium"
                  value={currentUser?.nom}
                  onChange={(e) => {
                    setcurrentUser({
                      ...currentUser,
                      nom: e.target.value,
                    });
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={8} style={{ textAlign: "center", padding: 5 }}>
                <span>Prenom</span>
              </Col>
              <Col span={16}>
                <Input
                  size="medium"
                  value={currentUser?.prenom}
                  onChange={(e) => {
                    setcurrentUser({
                      ...currentUser,
                      prenom: e.target.value,
                    });
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={8} style={{ textAlign: "center", padding: 5 }}>
                <span>Mobile</span>
              </Col>
              <Col span={16}>
                <Input
                  size="medium"
                  value={currentUser?.mobile}
                  onChange={(e) => {
                    setcurrentUser({
                      ...currentUser,
                      mobile: e.target.value,
                    });
                  }}
                />
              </Col>
            </Row>
          </Col>

          <Col span={12}>
            <Row>
              <Col span={8} style={{ textAlign: "center", padding: 5 }}>
                <span>Fonction</span>
              </Col>
              <Col span={16}>
                <Select
                  style={{ width: "100%", textAlign: "center" }}
                  value={currentUser?.fonction_id}
                  onChange={(value) => {
                    setcurrentUser({
                      ...currentUser,
                      fonction_id: value,
                    });
                  }}
                >
                  <Option key="1" value={1}>
                    Administrateur
                  </Option>
                  <Option key="2" value={2}>
                    User
                  </Option>
                </Select>
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={8} style={{ textAlign: "center", padding: 5 }}>
                <span>Password</span>
              </Col>
              <Col span={16}>
                <Input
                  size="medium"
                  value={currentUser?.password}
                  onChange={(e) => {
                    setcurrentUser({
                      ...currentUser,
                      password: e.target.value,
                    });
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={8} style={{ textAlign: "center", padding: 5 }}>
                <span>Confirm Password</span>
              </Col>
              <Col span={16}>
                <Input
                  size="medium"
                  value={currentUser?.password_confirm}
                  onChange={(e) => {
                    setcurrentUser({
                      ...currentUser,
                      password_confirm: e.target.value,
                    });
                  }}
                />
              </Col>
            </Row>
            <br/>
            <Row>
              <Col span={8} style={{ textAlign: "center", padding: 5 }}>
                <span>Agence</span>
              </Col>
              <Col span={16}>
                <Select
                  style={{ width: "100%", textAlign: "center" }}
                  value={currentUser?.agence_id}
                  onChange={(value) => {
                    setcurrentUser({
                      ...currentUser,
                      agence_id: value,
                    });
                  }}
                  placeholder="Sélectionnez une agence"
                >
                  <Option key="1" value={1}>Agence Antananarivo</Option>
                  <Option key="2" value={2}>Agence Fianarantsoa</Option>
                  <Option key="3" value={3}>Agence Toamasina</Option>
                  {/* 🔹 Tu peux générer dynamiquement les options depuis ton API */}
                </Select>
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal>

      <Modal
        title="Supprimer cet utilisateur"
        open={isModalDisableUser}
        onOk={handleOkDisableUser}
        onCancel={() => {
          setisModalDisableUser(false);
          setcurrentUser({
            id: 0,
            email: null,
            password: null,
            nom: null,
            prenom: null,
            fonction_id: null,
            password_confirm: null,
            mobile: "",
          });
        }}
        okText="Supprimer"
        cancelText="Annuler"
        width={800}
        style={{ top: 10 }}
        confirmLoading={isloading}
      >
        <Row>
          <h4>
            Voulez vous vraiment supprimer l'utilisateur {currentUser?.nom}?
          </h4>
        </Row>
      </Modal>

      <Modal
        open={isModalOpenRegion}
        title={isUpdateRegion ? "Modifier Région" : "Ajouter Région"}
        onCancel={() => {
          setisModalOpenRegion(false);
          setselectedRegion({ id: 0, nom: "" });
          setisUpdateRegion(false);
        }}
        onOk={handleEditRegion}
        okText={isUpdateRegion ? "Mettre à jour" : "Ajouter"}
        cancelText="Annuler"
        confirmLoading={isloading}
      >
        <Row>
          <Col span={24}>
            <Row>
              <Col span={8} style={{ textAlign: "center", padding: 5 }}>
                <span>Nom du région</span>
              </Col>
              <Col span={16}>
                <Input
                  size="medium"
                  value={selectedRegion?.nom}
                  onChange={(e) => {
                    setselectedRegion({
                      ...selectedRegion,
                      nom: e.target.value,
                    });
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal>

      <Modal
        title="Supprimer cette Région"
        open={isModalDeleteRegion}
        onOk={handleDeleteRegion}
        onCancel={() => {
          setisModalDeleteRegion(false);
          setselectedRegion({
            id: 0,
            nom: "",
          });
        }}
        okText="Supprimer"
        cancelText="Annuler"
        confirmLoading={isloading}
      >
        <p>
          Voulez-vous vraiment supprimer la région <strong>{selectedRegion?.nom}</strong> ?
        </p>
      </Modal>

      <Modal
        open={isModalOpenSite}
        title={isUpdateSite ? "Modifier le site" : "Ajouter un site"}
        onCancel={() => {
          setisModalOpenSite(false);
          setselectedSite({ id: 0, nom: "" });
          setisUpdateSite(false);
        }}
        onOk={handleEditSite}
        okText={isUpdateSite ? "Modifier" : "Ajouter"}
        cancelText={"Annuler"}
        confirmLoading={isloading}

      >
        <Row>
          <Col span={12}>
            <span>Nom du site </span>
          </Col>
          <Col span={12}>
            <Input
              size="medium"
              value={selectedSite?.nom}
              onChange={(e) => {
                setselectedSite({
                  ...selectedSite,
                  nom: e.target.value,
                });
              }}
            />
          </Col>
        </Row>
      </Modal>

      <Modal
        open={isModalDeleteSite}
        title={"Supprimer ce site"}
        onOk={handleDeleteSite}
        onCancel={() => {
          setisModalDeleteSite(false);
          setselectedSite({
            id: 0,
            nom: "",
          });
        }}
        okText="Supprimer"
        cancelText="Annuler"
        confirmLoading={isloading}
      >
        <span>
          Voulez-vous vraiment supprimer le site{" "}
          <strong>{selectedSite?.nom}</strong> ?
        </span>
      </Modal>

      <Modal
        open={isModalOpenType}
        title={isUpdateType ? "Modifier le type" : "Ajouter un type"}
        onCancel={() => {
          setisModalOpenType(false);
          setselectedType({ id: 0, nom: "" });
          setisUpdateType(false);
        }}
        onOk={handleEditType}
        okText={isUpdateType ? "Modifier" : "Ajouter"}
        cancelText={"Annuler"}
        confirmLoading={isloading}
      >
        <Row>
          <Col span={12}>
            <span>Type de camion</span>
          </Col>
          <Col span={12}>
            <Input
              size="medium"
              value={selectedType?.nom}
              onChange={(e) => {
                setselectedType({
                  ...selectedType,
                  nom: e.target.value,
                });
              }}
            />
          </Col>
        </Row>
      </Modal>

      <Modal
        open={isModalDeleteType}
        title={"Supprimer ce type de camion"}
        onOk={handleDeleteType}
        onCancel={() => setisModalDeleteType(false)}
        okText="Supprimer"
        cancelText="Annuler"
        confirmLoading={isloading}
      >
        <span>
          Voulez-vous vraiment supprimer le type de camion{" "}
          <strong>{selectedType?.nom}</strong>
        </span>
      </Modal>

      <Modal
        title="Créer une permission"
        open={isCreatePermissionModalOpen}
        okText="Créer"
        onCancel={() => {
          setIsCreatePermissionModalOpen(false);
          setPermissionData({ nom: "", description: "" });
        }}
        onOk={handleCreatePermission}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <label>Nom de la permission</label>
            <Input
              value={permissionData.nom}
              placeholder="ex: user.create"
              onChange={(e) =>
                setPermissionData({
                  ...permissionData,
                  nom: e.target.value,
                })
              }
            />
          </Col>

          <Col span={24}>
            <label>Description</label>
            <Input.TextArea
              rows={3}
              value={permissionData.description}
              placeholder="Description de la permission"
              onChange={(e) =>
                setPermissionData({
                  ...permissionData,
                  description: e.target.value,
                })
              }
            />
          </Col>
        </Row>
      </Modal>

      <Modal
        title={`Permissions – ${selectedUser?.prenom} ${selectedUser?.nom}`}
        open={isAssignPermissionModalOpen}
        onCancel={() => setIsAssignPermissionModalOpen(false)}
        onOk={handleSavePermissions}
        okText="Enregistrer"
        width={900}
      >
        <Space style={{ marginBottom: 8 }}>
          <Button
            size="small"
            onClick={() =>
              setUserPermissions(
                filteredPermissions.map((p) => p.id)
              )
            }
          >
            Tout cocher
          </Button>

          <Button
            size="small"
            danger
            onClick={() =>
              setUserPermissions(
                userPermissions.filter(
                  (id) =>
                    !filteredPermissions.some((p) => p.id === id)
                )
              )
            }
          >
            Tout décocher
          </Button>
        </Space>
        <Input
          placeholder="Rechercher une permission..."
          allowClear
          style={{ marginBottom: 12 }}
          onChange={(e) => setSearchPermission(e.target.value)}
        />

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "8px 16px",
            maxHeight: 420,
            overflowY: "auto",
            paddingRight: 8,
          }}
        >

          {filteredPermissions.map((perm) => (
            <Checkbox
              key={perm.id}
              checked={userPermissions.includes(perm.id)}
              onChange={(e) =>
                togglePermission(perm.id, e.target.checked)
              }
            >
              <div>
                <b>{perm.nom}</b>
                {perm.description && (
                  <div style={{ fontSize: 11, color: "#888" }}>
                    {perm.description}
                  </div>
                )}
              </div>
            </Checkbox>
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default Utility;
